import * as THREE from 'three'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
// import { OrbitControls } from 'three/addons/controls/OrbitControls.js'
import gsap from 'gsap'

export default class WebglKyoto {
  constructor(dom) {
    this.isScroll = false

    const windowWidth = window.innerWidth
    const breakPoint = 760
    this.container = dom
    const width = this.container.offsetWidth
    const height = this.container.offsetHeight

    this.scene = new THREE.Scene()
    this.camera = new THREE.PerspectiveCamera(
      45,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    )
    this.camera.aspect = width / height
    if (windowWidth <= breakPoint) {
      // mobile
      this.camera.position.set(18, -4, 170)
    } else {
      // pc
      this.camera.position.set(0, -24, 115)
    }

    this.renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true,
    })
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    this.renderer.setClearColor(0x000000, 0.0)
    this.renderer.setSize(width, height)
    this.renderer.outputEncoding = THREE.sRGBEncoding
    this.renderer.physicallyCorrectLights = true
    this.renderer.toneMapping = THREE.ACESFilmicToneMapping
    this.renderer.shadowMap.enabled = true
    this.renderer.gammaOutput = true
    this.renderer.gammaFactor = 1.0

    this.container.appendChild(this.renderer.domElement)

    // const controls = new OrbitControls(camera, renderer.domElement)
    // controls.zoomSpeed = 0.5
    // controls.update()

    const directionalLight = new THREE.DirectionalLight(0xaaaaaa, 3)
    const directionalLight2 = new THREE.DirectionalLight(0xaaaaaa, 1)
    const directionalLight3 = new THREE.DirectionalLight(0xaaaaaa, 7)
    const directionalLight4 = new THREE.DirectionalLight(0xffffff, 10)
    const directionalLight5 = new THREE.DirectionalLight(0xaaaaaa, 10)
    if (windowWidth <= breakPoint) {
    // mobile
      directionalLight.position.set(-0.1, 0.3, 0.3)
      directionalLight2.position.set(0.2, -0.1, -0.5)
      directionalLight3.position.set(0, 0.1, 0.5)
    } else {
      // pc
      directionalLight.position.set(0, 0.5, 0.5)
      directionalLight2.position.set(0, 0.3, 0.5)
      directionalLight3.position.set(0, -0.1, -0.1)
      directionalLight4.position.set(10, 0.9, -1.1)
      directionalLight5.position.set(-15, -10.1, 0)
    }
    this.scene.add(directionalLight)
    this.scene.add(directionalLight2)
    this.scene.add(directionalLight3)
    this.scene.add(directionalLight4)
    this.scene.add(directionalLight5)

    const loader = new GLTFLoader()

    let model = null

    if (windowWidth <= breakPoint) {
      // mobile
      loader.load(
        './assets/glb/bizarre_sp.glb',
        (gltf) => {
          model = gltf.scene
          this.redraw = model
          this.redraw.rotation.x = -0.2
          this.redraw.rotation.y = -0.2
          gsap.to(this.redraw.rotation, {
            duration: 40000,
            y: 360,
            x: 360,
            z: 360,
            ease: 'none',
            repeat: -1,
          });
          model.scale.set(1, 1, 1)
          this.scene.add(model)
        },
        undefined,
        function (error) {
          console.error(error)
        }
      )
    } else {
      // pc
      loader.load(
        './assets/glb/bizarre.glb',
        (gltf) => {
          model = gltf.scene
          this.redraw = model
          this.redraw.rotation.x = -0.2
          gsap.to(this.redraw.rotation, {
            duration: 50000,
            y: 360,
            x: 360,
            z: 360,
            ease: 'none',
            repeat: -1,
          });
          model.scale.set(0.8, 0.8, 0.8)
          this.scene.add(model)
        },
        undefined,
        function (error) {
          console.error(error)
        }
      )
    }

    this.render()
    this.addEvents()
    this.onResize()

    window.addEventListener('scroll', () => {
      if (window.scrollY >= 100) this.isScroll = true
    })
  }

  render() {
    this.renderer.render(this.scene, this.camera)
    requestAnimationFrame(this.render.bind(this))

    if (this.isScroll) {
      gsap.to(this.redraw.rotation, {
        duration: 8,
        x: 0,
        y: 6.3,
        ease: 'expo.out',
      })
    }
  }

  addEvents() {
    window.addEventListener('resize', this.onResize.bind(this))
  }

  onResize() {
    const w = this.container.offsetWidth
    const h = this.container.offsetHeight
    const dpr = Math.min(window.devicePixelRatio, 2);
    this.camera.aspect = w / h
    this.camera.updateProjectionMatrix()
    this.renderer.setSize(w, h)
    this.renderer.setPixelRatio(dpr)
  }
}
